var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('v-toolbar',{attrs:{"dense":"","src":"https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"}},[_c('v-spacer')],1),_c('OrderForm',{attrs:{"order":_vm.defaultItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }